(() => {
  if (window.__xmkPdpScriptReady) {
    window.__xmkPdpInit?.(document, { force: true });
    return;
  }

  window.__xmkPdpScriptReady = true;
  window.__xmkPdpPatchVersion = 'xmk-integrated-tabs-20260707-v1';

  const defaultFacebookGroupUrl = 'https://www.facebook.com/groups/1498679638929020';

  const getYouTubeEmbedUrl = (url) => {
    if (!url) return '';

    try {
      const parsed = new URL(url, window.location.origin);
      let id = '';

      if (parsed.hostname.includes('youtu.be')) {
        id = parsed.pathname.replace('/', '');
      } else if (parsed.searchParams.has('v')) {
        id = parsed.searchParams.get('v');
      } else if (parsed.pathname.includes('/embed/')) {
        id = parsed.pathname.split('/embed/')[1].split('/')[0];
      } else if (parsed.pathname.includes('/shorts/')) {
        id = parsed.pathname.split('/shorts/')[1].split('/')[0];
      }

      if (!id) return url;

      const start = parsed.searchParams.get('t') || parsed.searchParams.get('start');
      const startSeconds = start && start.endsWith('s') ? start.slice(0, -1) : start;
      const embed = new URL(`https://www.youtube.com/embed/${id}`);
      embed.searchParams.set('autoplay', '1');
      embed.searchParams.set('rel', '0');
      embed.searchParams.set('modestbranding', '1');

      if (startSeconds) embed.searchParams.set('start', startSeconds);

      return embed.toString();
    } catch (error) {
      return url;
    }
  };

  const keyFeatureCopy = {
    compact: {
      title: 'Ultra-Compact Design',
      body: 'Desktop-Sized for Any Studio',
      mobileTitle: 'Ultra-Compact Design'
    },
    workflow: {
      title: '<em>5-in-1</em> Integrated DTF Workflow',
      body: 'One-Click Operation,<br>From Print to Cure',
      mobileTitle: '<em>5-in-1</em> Integrated DTF Workflow'
    },
    eco: {
      title: 'Built-in<br>Air Purification',
      body: 'Dust-Free<br><span class="xmk-text-nowrap">Eco-Friendly</span> Printing',
      mobileTitle: 'Built-in<br>Air Purification'
    },
    support: {
      title: 'Worry-Free Support',
      body: 'Support by <span style="color: #734FE9;">Besender</span>',
      mobileTitle: 'Worry-Free Support'
    },
    studio: {
      title: 'XtraMaker Studio App',
      body: '3D Mockup with AI Tools',
      mobileTitle: 'XtraMaker Studio App'
    },
    user: {
      title: 'Safe &amp; Simple',
      body: 'No exposed heat.<br>No powder contact.',
      mobileTitle: 'Safe &amp; Simple'
    },
    maintenance: {
      title: 'Effortless Maintenance',
      body: 'Enjoy hassle-free upkeep all year round.',
      mobileTitle: 'Effortless Maintenance'
    },
    quality: {
      title: 'True Color Fidelity',
      body: '· G7 Certified Color Accuracy<br>· 1440*1440 DPI High Resolution<br>· Print on Any Fabric',
      mobileTitle: 'True Color Fidelity'
    }
  };

  const setHtml = (element, html) => {
    if (!element || element.innerHTML === html) return;
    element.innerHTML = html;
  };

  const normalizeKeyFeaturesCopy = (scope = document) => {
    const sections = new Set();

    if (scope.matches?.('.xmk-features[data-xmk-section="features"]')) {
      sections.add(scope);
    }

    scope.querySelectorAll?.('.xmk-features[data-xmk-section="features"]').forEach((section) => {
      sections.add(section);
    });

    sections.forEach((section) => {
      Object.entries(keyFeatureCopy).forEach(([feature, copy]) => {
        section.querySelectorAll(`.xmk-feature-card--${feature}`).forEach((card) => {
          setHtml(card.querySelector('h3'), copy.title);

          let body = card.querySelector('.xmk-feature-card__text p');
          if (!body) {
            body = document.createElement('p');
            card.querySelector('.xmk-feature-card__text')?.appendChild(body);
          }
          setHtml(body, copy.body);
        });

        section.querySelectorAll(`.xmk-mobile-feature-tile--${feature}`).forEach((tile) => {
          setHtml(tile.querySelector('h3'), copy.mobileTitle);
        });
      });
    });
  };

  const normalizeIntegratedTabCopy = (scope = document) => {
    const tabs = [];

    if (scope.matches?.('[data-xmk-anchor-tab], [data-xmk-product-anchor-tab]')) {
      tabs.push(scope);
    }

    scope.querySelectorAll?.('[data-xmk-anchor-tab], [data-xmk-product-anchor-tab]').forEach((tab) => {
      tabs.push(tab);
    });

    tabs.forEach((tab) => {
      if (tab.textContent.trim() === 'integrate DTF Workflow') {
        tab.textContent = 'Integrated DTF Workflow';
      }
    });
  };

  const compareAssetNames = {
    desktop: {
      pro: 'xmk-compare-pro-frontal-transparent.png',
      m1: 'xmk-compare-m1-frontal-transparent.png',
      industrial: 'xmk-fzt-industrial.png'
    },
    mobile: {
      pro: 'xmk-compare-pro-frontal-transparent.png',
      m1: 'xmk-compare-m1-frontal-transparent.png',
      industrial: 'xmk-fzt-industrial.png'
    }
  };

  const getThemeAssetUrl = (image, assetName) => {
    const current = image?.currentSrc || image?.src || '';
    const match = current.match(/^(.*\/assets\/)[^/?#]+/);

    return match ? `${match[1]}${assetName}` : '';
  };

  const setCompareImageAsset = (item, assetName) => {
    const image = item?.querySelector('img');
    if (!image || !assetName) return;
    if ((image.currentSrc || image.src || '').includes(assetName)) return;

    const nextSrc = getThemeAssetUrl(image, assetName);
    if (!nextSrc) return;

    image.src = nextSrc;
    image.removeAttribute('srcset');
    image.removeAttribute('data-src');
    image.removeAttribute('data-srcset');
  };

  class XtraMakerPdp {
    constructor(root) {
      normalizeKeyFeaturesCopy(root);

      this.root = root;
      this.modal = root.querySelector('[data-xmk-video-modal]') || document.querySelector('[data-xmk-video-modal]');
      this.frame = this.modal?.querySelector('[data-xmk-video-frame]') || root.querySelector('[data-xmk-video-frame]');
      this.closeButtons = this.modal?.querySelectorAll('[data-xmk-video-close]') || root.querySelectorAll('[data-xmk-video-close]');
      this.lastActiveElement = null;
      this.disposers = [];
      this.handleKeydown = this.handleKeydown.bind(this);

      this.bindTabs();
      this.bindCompareSwitchers();
      this.bindSceneSliders();
      this.bindCarousels();
      this.bindVideo();
      this.bindFacebookGroupSubmits();
      this.bindMaintenanceStack();
    }

    bindFacebookGroupSubmits() {
      this.root.querySelectorAll('form.xmk-newsletter').forEach((form) => {
        if (form.dataset.xmkFacebookGroupSubmitBound === 'true') return;

        const submitButton = form.querySelector('button[type="submit"], input[type="submit"]');
        const urlProvider = form.closest('[data-xmk-facebook-group-url]') || this.root;
        const facebookGroupUrl = urlProvider?.dataset?.xmkFacebookGroupUrl || defaultFacebookGroupUrl;
        let lastOpenAt = 0;

        if (!facebookGroupUrl) return;

        const openFacebookGroup = () => {
          if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;

          const now = Date.now();
          if (now - lastOpenAt < 1200) return;

          const opened = window.open(facebookGroupUrl, '_blank', 'noopener,noreferrer');
          if (opened) {
            opened.opener = null;
          }
          lastOpenAt = now;
        };

        form.dataset.xmkFacebookGroupSubmitBound = 'true';
        submitButton?.addEventListener('pointerup', openFacebookGroup);
        submitButton?.addEventListener('click', openFacebookGroup);
        form.addEventListener('submit', openFacebookGroup);

        this.disposers.push(() => {
          submitButton?.removeEventListener('pointerup', openFacebookGroup);
          submitButton?.removeEventListener('click', openFacebookGroup);
          form.removeEventListener('submit', openFacebookGroup);
          delete form.dataset.xmkFacebookGroupSubmitBound;
        });
      });
    }

    bindVideo() {
      const handleRootClick = (event) => {
        if (event.target.closest?.('[data-xmk-video-modal]')) return;

        const directTrigger = event.target.closest?.('[data-video-url]');
        const trigger = directTrigger && this.root.contains(directTrigger)
          ? directTrigger
          : this.findVideoTriggerAtPoint(event.clientX, event.clientY);

        if (!trigger) return;
        this.handleVideoTrigger(event, trigger);
      };

      this.root.addEventListener('click', handleRootClick, true);
      this.disposers.push(() => this.root.removeEventListener('click', handleRootClick, true));

      this.root.querySelectorAll('[data-video-url]').forEach((trigger) => {
        const handleClick = (event) => {
          this.handleVideoTrigger(event, trigger);
        };

        trigger.addEventListener('click', handleClick);
        this.disposers.push(() => trigger.removeEventListener('click', handleClick));
      });

      this.closeButtons.forEach((button) => {
        const handleClose = () => this.closeVideo();

        button.addEventListener('click', handleClose);
        this.disposers.push(() => button.removeEventListener('click', handleClose));
      });

      document.addEventListener('keydown', this.handleKeydown);
      this.disposers.push(() => document.removeEventListener('keydown', this.handleKeydown));
    }

    handleVideoTrigger(event, trigger) {
      if (event.xmkVideoHandled) return;

      const videoUrl = trigger.getAttribute('data-video-url')?.trim();
      if (!videoUrl) return;

      event.xmkVideoHandled = true;

      if (!this.modal || !this.frame) {
        event.preventDefault();
        window.open(videoUrl, '_blank', 'noopener');
        return;
      }

      event.preventDefault();
      this.openVideo(videoUrl, trigger);
    }

    findVideoTriggerAtPoint(x, y) {
      if (!Number.isFinite(x) || !Number.isFinite(y)) return null;

      return Array.from(this.root.querySelectorAll('[data-video-url]')).find((trigger) => {
        const rect = trigger.getBoundingClientRect();
        if (rect.width <= 0 || rect.height <= 0) return false;

        const styles = window.getComputedStyle(trigger);
        if (styles.display === 'none' || styles.visibility === 'hidden' || styles.pointerEvents === 'none') return false;

        return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
      });
    }

    normalizeIndex(index, count) {
      return (index + count) % count;
    }

    bindHorizontalSwipe({ surfaces, count, getIndex, onNavigate }) {
      if (!surfaces.length || count < 2) return;

      surfaces.forEach((surface) => {
        let drag = null;

        const handlePointerDown = (event) => {
          if (event.button !== undefined && event.button !== 0) return;
          if (event.target.closest('a, button, input, select, textarea, [contenteditable="true"]')) return;

          drag = {
            id: event.pointerId,
            startX: event.clientX,
            startY: event.clientY,
            isHorizontal: false,
            isVertical: false
          };
          surface.setPointerCapture?.(event.pointerId);
        };

        const handlePointerMove = (event) => {
          if (!drag || drag.id !== event.pointerId) return;

          const deltaX = event.clientX - drag.startX;
          const deltaY = event.clientY - drag.startY;
          const absX = Math.abs(deltaX);
          const absY = Math.abs(deltaY);

          if (!drag.isHorizontal && !drag.isVertical && (absX > 8 || absY > 8)) {
            drag.isHorizontal = absX > absY * 1.2;
            drag.isVertical = !drag.isHorizontal;
          }

          if (drag.isHorizontal) {
            event.preventDefault();
          }
        };

        const handlePointerEnd = (event) => {
          if (!drag || drag.id !== event.pointerId) return;

          const deltaX = event.clientX - drag.startX;
          const deltaY = event.clientY - drag.startY;
          const threshold = Math.max(36, Math.min(86, surface.clientWidth * 0.16));
          const shouldNavigate = Math.abs(deltaX) >= threshold && Math.abs(deltaX) > Math.abs(deltaY) * 1.2;
          const currentIndex = getIndex();
          drag = null;
          surface.releasePointerCapture?.(event.pointerId);

          if (!shouldNavigate || currentIndex < 0) return;

          const direction = deltaX < 0 ? 1 : -1;
          onNavigate(this.normalizeIndex(currentIndex + direction, count));
        };

        surface.addEventListener('pointerdown', handlePointerDown);
        surface.addEventListener('pointermove', handlePointerMove);
        surface.addEventListener('pointerup', handlePointerEnd);
        surface.addEventListener('pointercancel', handlePointerEnd);

        this.disposers.push(() => surface.removeEventListener('pointerdown', handlePointerDown));
        this.disposers.push(() => surface.removeEventListener('pointermove', handlePointerMove));
        this.disposers.push(() => surface.removeEventListener('pointerup', handlePointerEnd));
        this.disposers.push(() => surface.removeEventListener('pointercancel', handlePointerEnd));
      });
    }

    shouldBindMobileTabSwipe(group) {
      return group.matches(
        '.xmk-mobile-profit-exact, .xmk-mobile-workflow-detail, .xmk-mobile-quality-body, .xmk-mobile-studio-exact'
      );
    }

    getMobileTabSwipeSurfaces(group, panels) {
      const surfaces = new Set();
      const tablist = group.querySelector('[role="tablist"]');
      if (tablist) surfaces.add(tablist);

      panels.forEach((panel) => {
        const parent = panel.parentElement;
        if (parent && parent !== group && !parent.matches('[role="tablist"]')) {
          surfaces.add(parent);
        }
        surfaces.add(panel);
      });

      return Array.from(surfaces).filter(Boolean);
    }

    bindTabs() {
      this.root.querySelectorAll('[data-xmk-tabs]').forEach((group) => {
        const tabs = Array.from(group.querySelectorAll('[data-xmk-tab]'));
        const panels = Array.from(group.querySelectorAll('[data-xmk-panel]'));
        if (!tabs.length || !panels.length) return;
        const scrollTabIntoView = (tab, behavior = 'smooth', phase = 'activate') => {
          const strip = tab.parentElement;
          if (!strip || strip.scrollWidth <= strip.clientWidth) return;

          const maxLeft = Math.max(0, strip.scrollWidth - strip.clientWidth);
          const tabIndex = tabs.indexOf(tab);
          const mode = strip.dataset.xmkTabScrollMode;
          let targetLeft = tab.offsetLeft + tab.offsetWidth / 2 - strip.clientWidth / 2;

          if (mode === 'edge-aware') {
            if (phase === 'init' || tabIndex < tabs.length - 1) {
              targetLeft = 0;
            } else if (tabIndex >= tabs.length - 1) {
              targetLeft = tab.offsetLeft + tab.offsetWidth - strip.clientWidth;
            }
          }

          strip.scrollTo({
            left: Math.max(0, Math.min(targetLeft, maxLeft)),
            behavior
          });
        };

        const activateTab = (tab) => {
          const target = tab.getAttribute('data-xmk-tab');

          tabs.forEach((item) => {
            const isActive = item === tab;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-selected', isActive ? 'true' : 'false');
            item.setAttribute('tabindex', isActive ? '0' : '-1');
          });

          panels.forEach((panel) => {
            const isActive = panel.getAttribute('data-xmk-panel') === target;
            panel.classList.toggle('is-active', isActive);
            panel.hidden = !isActive;
          });

          scrollTabIntoView(tab);
        };

        tabs.forEach((tab, index) => {
          const handleTabClick = () => activateTab(tab);
          const handleTabKeydown = (event) => {
            const keyMap = {
              ArrowLeft: index === 0 ? tabs.length - 1 : index - 1,
              ArrowRight: index === tabs.length - 1 ? 0 : index + 1,
              Home: 0,
              End: tabs.length - 1
            };

            if (!(event.key in keyMap)) return;

            event.preventDefault();
            const nextTab = tabs[keyMap[event.key]];
            nextTab.focus({ preventScroll: true });
            activateTab(nextTab);
          };

          tab.addEventListener('click', handleTabClick);
          tab.addEventListener('keydown', handleTabKeydown);
          this.disposers.push(() => tab.removeEventListener('click', handleTabClick));
          this.disposers.push(() => tab.removeEventListener('keydown', handleTabKeydown));
        });

        if (this.shouldBindMobileTabSwipe(group)) {
          this.bindHorizontalSwipe({
            surfaces: this.getMobileTabSwipeSurfaces(group, panels),
            count: tabs.length,
            getIndex: () => tabs.findIndex((tab) => tab.classList.contains('is-active')),
            onNavigate: (index) => activateTab(tabs[index])
          });
        }

        const activeTab = tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0];
        if (activeTab) {
          window.requestAnimationFrame(() => scrollTabIntoView(activeTab, 'auto', 'init'));
        }
      });
    }

    bindCompareSwitchers() {
      this.root.querySelectorAll('[data-xmk-compare]').forEach((compare) => {
        const tabs = Array.from(compare.querySelectorAll('[data-xmk-compare-tab]'));
        if (!tabs.length) return;

        const mobileItems = compare.classList.contains('xmk-mobile-compare-exact')
          ? Array.from(compare.querySelectorAll('[data-xmk-compare-item]'))
          : [];
        const allowedStates = ['pro', 'm1'];

        const setActive = (nextState) => {
          const activeState = allowedStates.includes(nextState) ? nextState : 'pro';
          compare.dataset.active = activeState;

          tabs.forEach((tab) => {
            const isActive = tab.dataset.xmkCompareTab === activeState;
            tab.classList.toggle('is-active', isActive);
            tab.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });

          mobileItems.forEach((item) => {
            const key = item.dataset.xmkCompareItem;
            const shouldHide = activeState === 'pro' ? key === 'm1' : key === 'industrial';
            item.setAttribute('aria-hidden', shouldHide ? 'true' : 'false');
          });

          this.normalizeCompareVisuals(compare, activeState);
        };
        const getActiveIndex = () => {
          const activeState = compare.dataset.active;
          const nextIndex = allowedStates.indexOf(activeState);
          return nextIndex >= 0 ? nextIndex : 0;
        };

        tabs.forEach((tab, index) => {
          const handleClick = () => setActive(tab.dataset.xmkCompareTab);
          const handleKeydown = (event) => {
            const keyMap = {
              ArrowLeft: index === 0 ? tabs.length - 1 : index - 1,
              ArrowRight: index === tabs.length - 1 ? 0 : index + 1,
              Home: 0,
              End: tabs.length - 1
            };

            if (!(event.key in keyMap)) return;

            event.preventDefault();
            const nextTab = tabs[keyMap[event.key]];
            nextTab.focus({ preventScroll: true });
            setActive(nextTab.dataset.xmkCompareTab);
          };

          tab.addEventListener('click', handleClick);
          tab.addEventListener('keydown', handleKeydown);
          this.disposers.push(() => tab.removeEventListener('click', handleClick));
          this.disposers.push(() => tab.removeEventListener('keydown', handleKeydown));
        });

        if (compare.classList.contains('xmk-mobile-compare-exact')) {
          this.bindHorizontalSwipe({
            surfaces: Array.from(compare.querySelectorAll('.xmk-mobile-compare-card, .xmk-mobile-tabs--compare')),
            count: allowedStates.length,
            getIndex: getActiveIndex,
            onNavigate: (index) => setActive(allowedStates[index])
          });
        }

        setActive(compare.dataset.active);
      });
    }

    normalizeCompareVisuals(compare, activeState) {
      const isMobile = compare.classList.contains('xmk-mobile-compare-exact');
      const assets = isMobile ? compareAssetNames.mobile : compareAssetNames.desktop;
      const itemClass = isMobile ? 'xmk-mobile-compare-card__item' : 'xmk-compare-column';

      Object.entries(assets).forEach(([key, assetName]) => {
        const item =
          compare.querySelector(`[data-xmk-compare-item="${key}"]`) ||
          compare.querySelector(`.${itemClass}--${key}`);

        if (!item) return;

        setCompareImageAsset(item, assetName);

        const heading = item.querySelector('h3');
        if (!heading || (key !== 'pro' && key !== 'm1')) return;

        if (key === activeState) {
          heading.style.color = '#fff';
        } else {
          heading.style.removeProperty('color');
        }
      });
    }

    bindLoopingCarousel({ track, prev, next, progressItems = [], getViewportWidth, initialAlignment = 'start' }) {
      track.querySelectorAll('[data-xmk-loop-clone]').forEach((slide) => slide.remove());

      const originals = Array.from(track.children);
      if (!track || !prev || !next || originals.length < 2) return false;

      const normalizeIndex = (index) => (index + originals.length) % originals.length;
      const cleanCloneAttributes = (element) => {
        if (!element?.attributes) return;

        Array.from(element.attributes).forEach((attribute) => {
          if (attribute.name === 'id' || attribute.name.startsWith('data-shopify')) {
            element.removeAttribute(attribute.name);
          }
        });
        Array.from(element.children || []).forEach(cleanCloneAttributes);
      };
      const createClone = (slide, index, role) => {
        const clone = slide.cloneNode(true);
        cleanCloneAttributes(clone);
        clone.dataset.xmkLoopClone = 'true';
        clone.dataset.xmkLoopRole = role;
        clone.dataset.xmkSlideIndex = String(index);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((item) => {
          item.setAttribute('tabindex', '-1');
        });

        return clone;
      };

      originals.forEach((slide, index) => {
        slide.dataset.xmkLoopRole = 'original';
        slide.dataset.xmkSlideIndex = String(index);
      });

      const beforeClones = originals.map((slide, index) => createClone(slide, index, 'before'));
      const afterClones = originals.map((slide, index) => createClone(slide, index, 'after'));
      beforeClones.forEach((clone) => track.insertBefore(clone, originals[0]));
      afterClones.forEach((clone) => track.appendChild(clone));

      let activeIndex = 0;
      let currentOffset = 0;
      let centerMode = initialAlignment === 'center';
      let pendingJumpIndex = null;
      let jumpTimer = null;
      let startX = null;
      let startOffset = 0;
      const leftFadeSurface = track.closest(
        '.xmk-scenes__viewport, .xmk-showcase__viewport, .xmk-testimonials__viewport, .xmk-mobile-scenes-strip, .xmk-mobile-video-showcase, .xmk-mobile-voices-exact, .xmk-mobile-support-exact'
      );
      const activateLeftFade = () => {
        leftFadeSurface?.classList.add('is-left-fade-active');
      };

      const getRenderedSlides = () => Array.from(track.children);
      const getMaxOffset = () => Math.max(0, track.scrollWidth - getViewportWidth());
      const clampOffset = (offset) => Math.max(0, Math.min(offset, getMaxOffset()));
      const getSlideWidth = (slide) => slide?.getBoundingClientRect().width || slide?.offsetWidth || 0;
      const getStartOffsetForSlide = (slide) => clampOffset(slide ? slide.offsetLeft : 0);
      const getCenteredOffsetForSlide = (slide) => {
        if (!slide) return 0;

        return clampOffset(slide.offsetLeft + getSlideWidth(slide) / 2 - getViewportWidth() / 2);
      };
      const getOffsetForSlide = (slide, center) => (
        center ? getCenteredOffsetForSlide(slide) : getStartOffsetForSlide(slide)
      );
      const getTargetSlide = (targetIndex) => {
        const normalizedIndex = normalizeIndex(targetIndex);

        if (targetIndex < 0) return beforeClones[normalizedIndex] || originals[normalizedIndex];
        if (targetIndex >= originals.length) return afterClones[normalizedIndex] || originals[normalizedIndex];

        return originals[normalizedIndex];
      };
      const getNearestRenderedSlideForOffset = (offset) => {
        const viewportCenter = offset + getViewportWidth() / 2;
        let nearestSlide = originals[activeIndex];
        let nearestDistance = Number.POSITIVE_INFINITY;

        getRenderedSlides().forEach((slide) => {
          const slideCenter = slide.offsetLeft + getSlideWidth(slide) / 2;
          const distance = Math.abs(slideCenter - viewportCenter);

          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestSlide = slide;
          }
        });

        return nearestSlide;
      };
      const getNearestIndexForOffset = (offset) => {
        const nearestSlide = getNearestRenderedSlideForOffset(offset);
        return normalizeIndex(Number(nearestSlide?.dataset.xmkSlideIndex) || 0);
      };
      const getTargetIndexForRenderedSlide = (slide) => {
        const slideIndex = Number(slide?.dataset.xmkSlideIndex) || 0;
        const role = slide?.dataset.xmkLoopRole;

        if (role === 'before') return slideIndex - originals.length;
        if (role === 'after') return slideIndex + originals.length;

        return slideIndex;
      };
      const updateSlideStates = () => {
        const previousIndex = normalizeIndex(activeIndex - 1);
        const nextIndex = normalizeIndex(activeIndex + 1);

        getRenderedSlides().forEach((slide) => {
          const slideIndex = Number(slide.dataset.xmkSlideIndex);

          slide.classList.toggle('is-active', slideIndex === activeIndex);
          slide.classList.toggle('is-prev', slideIndex === previousIndex);
          slide.classList.toggle('is-next', slideIndex === nextIndex);
        });
        progressItems.forEach((item, index) => item.classList.toggle('is-active', index === activeIndex));
        prev.removeAttribute('disabled');
        next.removeAttribute('disabled');
      };
      const getTransitionMs = () => {
        const styles = window.getComputedStyle(track);
        const durations = styles.transitionDuration.split(',').map((duration) => duration.trim());
        const delays = styles.transitionDelay.split(',').map((delay) => delay.trim());
        const toMilliseconds = (value) => {
          if (value.endsWith('ms')) return Number.parseFloat(value);
          if (value.endsWith('s')) return Number.parseFloat(value) * 1000;
          return Number.parseFloat(value) || 0;
        };

        return Math.max(
          0,
          ...durations.map((duration, index) => (
            toMilliseconds(duration) + toMilliseconds(delays[index] || delays[0] || '0s')
          ))
        );
      };
      const clearJumpTimer = () => {
        if (!jumpTimer) return;

        window.clearTimeout(jumpTimer);
        jumpTimer = null;
      };
      const setOffsetForSlide = (slide, { center = centerMode, animate = true } = {}) => {
        currentOffset = getOffsetForSlide(slide, center);
        track.style.transition = animate ? '' : 'none';
        track.style.transform = `translate3d(${-currentOffset}px, 0, 0)`;
        updateSlideStates();

        if (!animate) {
          window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
              track.style.transition = '';
            });
          });
        }
      };
      const jumpToPendingSlide = () => {
        if (pendingJumpIndex === null) return;

        const jumpIndex = pendingJumpIndex;
        pendingJumpIndex = null;
        clearJumpTimer();
        activeIndex = jumpIndex;
        setOffsetForSlide(originals[jumpIndex], { center: true, animate: false });
      };
      const goTo = (targetIndex, { center = true, animate = true } = {}) => {
        clearJumpTimer();
        activeIndex = normalizeIndex(targetIndex);
        centerMode = center;

        const targetSlide = getTargetSlide(targetIndex);
        pendingJumpIndex = targetSlide?.dataset.xmkLoopRole === 'original' ? null : activeIndex;
        setOffsetForSlide(targetSlide, { center, animate });

        if (pendingJumpIndex !== null && animate) {
          jumpTimer = window.setTimeout(jumpToPendingSlide, getTransitionMs() + 80);
        }
      };
      const handleTransitionEnd = (event) => {
        if (event.target !== track || pendingJumpIndex === null) return;

        jumpToPendingSlide();
      };
      const setDraggedOffset = (offset) => {
        clearJumpTimer();
        currentOffset = clampOffset(offset);
        activeIndex = getNearestIndexForOffset(currentOffset);
        track.style.transition = 'none';
        track.style.transform = `translate3d(${-currentOffset}px, 0, 0)`;
        updateSlideStates();
      };
      const handlePrev = () => {
        activateLeftFade();
        goTo(activeIndex - 1);
      };
      const handleNext = () => {
        activateLeftFade();
        goTo(activeIndex + 1);
      };
      const progressDisposers = progressItems.map((item, index) => {
        const isAriaHidden = Boolean(item.closest('[aria-hidden="true"]'));
        const handleProgressClick = () => {
          activateLeftFade();
          goTo(index);
        };
        const handleProgressKeydown = (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;

          event.preventDefault();
          handleProgressClick();
        };

        item.addEventListener('click', handleProgressClick);
        if (!isAriaHidden) {
          item.setAttribute('role', 'button');
          item.setAttribute('tabindex', '0');
          item.setAttribute('aria-label', `Go to slide ${index + 1}`);
          item.addEventListener('keydown', handleProgressKeydown);
        }

        return () => {
          item.removeEventListener('click', handleProgressClick);
          if (!isAriaHidden) {
            item.removeEventListener('keydown', handleProgressKeydown);
            item.removeAttribute('role');
            item.removeAttribute('tabindex');
            item.removeAttribute('aria-label');
          }
        };
      });
      const handleResize = () => goTo(activeIndex, { center: centerMode, animate: false });
      const handlePointerDown = (event) => {
        if (event.button !== undefined && event.button !== 0) return;

        activateLeftFade();
        clearJumpTimer();
        pendingJumpIndex = null;
        startX = event.clientX;
        startOffset = currentOffset;
        track.classList.add('is-dragging');
        track.setPointerCapture?.(event.pointerId);
        track.style.transition = 'none';
      };
      const handlePointerMove = (event) => {
        if (startX === null) return;

        setDraggedOffset(startOffset - (event.clientX - startX));
        event.preventDefault();
      };
      const handlePointerUp = (event) => {
        if (startX === null) return;

        startX = null;
        centerMode = true;
        track.classList.remove('is-dragging');
        track.releasePointerCapture?.(event.pointerId);
        goTo(getTargetIndexForRenderedSlide(getNearestRenderedSlideForOffset(currentOffset)), { center: true });
      };

      prev.addEventListener('click', handlePrev);
      next.addEventListener('click', handleNext);
      track.addEventListener('transitionend', handleTransitionEnd);
      track.addEventListener('pointerdown', handlePointerDown);
      track.addEventListener('pointermove', handlePointerMove);
      track.addEventListener('pointerup', handlePointerUp);
      track.addEventListener('pointercancel', handlePointerUp);
      window.addEventListener('resize', handleResize);

      goTo(0, { center: centerMode, animate: false });

      this.disposers.push(() => prev.removeEventListener('click', handlePrev));
      this.disposers.push(() => next.removeEventListener('click', handleNext));
      progressDisposers.forEach((dispose) => this.disposers.push(dispose));
      this.disposers.push(() => track.removeEventListener('transitionend', handleTransitionEnd));
      this.disposers.push(() => track.removeEventListener('pointerdown', handlePointerDown));
      this.disposers.push(() => track.removeEventListener('pointermove', handlePointerMove));
      this.disposers.push(() => track.removeEventListener('pointerup', handlePointerUp));
      this.disposers.push(() => track.removeEventListener('pointercancel', handlePointerUp));
      this.disposers.push(() => window.removeEventListener('resize', handleResize));
      this.disposers.push(() => {
        clearJumpTimer();
        beforeClones.concat(afterClones).forEach((clone) => clone.remove());
        originals.forEach((slide) => {
          delete slide.dataset.xmkLoopRole;
          delete slide.dataset.xmkSlideIndex;
          slide.classList.remove('is-active', 'is-prev', 'is-next');
        });
      });

      return true;
    }

    bindSceneSliders() {
      this.root.querySelectorAll('[data-xmk-scenes]').forEach((controls) => {
        const section = controls.closest('.xmk-creators');
        const track = section?.querySelector('[data-xmk-scenes-track]');
        const prev = controls.querySelector('[data-xmk-scenes-prev]');
        const next = controls.querySelector('[data-xmk-scenes-next]');
        const progressItems = Array.from(controls.querySelectorAll('.xmk-scenes__progress span'));

        if (!track || !prev || !next) return;

        const getViewportWidth = () => {
          const container = track.closest('.xmk-container');
          return container ? container.clientWidth : track.parentElement?.clientWidth || track.clientWidth;
        };

        this.bindLoopingCarousel({ track, prev, next, progressItems, getViewportWidth, initialAlignment: 'center' });
      });
    }

    bindCarousels() {
      this.root.querySelectorAll('[data-xmk-carousel]').forEach((carousel) => {
        const track = carousel.querySelector('[data-xmk-carousel-track]');
        const showcaseControls = carousel.classList.contains('xmk-showcase__carousel')
          ? carousel.closest('.xmk-showcase')?.querySelector('.xmk-showcase__controls')
          : null;
        const controlsRoot = showcaseControls || carousel;
        const prev = controlsRoot.querySelector('[data-xmk-carousel-prev]');
        const next = controlsRoot.querySelector('[data-xmk-carousel-next]');

        if (!track || !prev || !next) return;

        if (
          carousel.classList.contains('xmk-testimonials') ||
          carousel.classList.contains('xmk-showcase__carousel') ||
          carousel.classList.contains('xmk-mobile-video-carousel') ||
          carousel.classList.contains('xmk-mobile-scenes-strip') ||
          carousel.classList.contains('xmk-mobile-voices-exact') ||
          carousel.classList.contains('xmk-mobile-support-exact')
        ) {
          const progressItems = Array.from(carousel.querySelectorAll('.xmk-mobile-slider-ui span'));
          if (carousel.classList.contains('xmk-testimonials')) {
            progressItems.push(...carousel.querySelectorAll('.xmk-testimonials__progress span'));
          }
          if (carousel.classList.contains('xmk-showcase__carousel')) {
            progressItems.push(...controlsRoot.querySelectorAll('.xmk-showcase__progress span'));
          }
          const getViewportWidth = () => {
            const parentWidth = track.parentElement?.getBoundingClientRect().width || 0;
            const carouselWidth = carousel.getBoundingClientRect().width || parentWidth || track.clientWidth;

            if (carousel.classList.contains('xmk-mobile-video-carousel')) {
              const trackInset = Number.parseFloat(window.getComputedStyle(track).left) || 0;

              return Math.max(1, carouselWidth - trackInset * 2);
            }

            if (carousel.classList.contains('xmk-mobile-scenes-strip')) {
              const trackInset = Number.parseFloat(window.getComputedStyle(track).left) || 0;

              return Math.max(1, carouselWidth - trackInset * 2);
            }

            if (carousel.classList.contains('xmk-mobile-voices-exact')) {
              return Math.max(1, carouselWidth - 30);
            }

            if (carousel.classList.contains('xmk-mobile-support-exact')) {
              return Math.max(1, Math.min(345, carouselWidth - 30));
            }

            return carouselWidth;
          };

          const initialAlignment =
            carousel.classList.contains('xmk-showcase__carousel') ||
            carousel.classList.contains('xmk-mobile-video-carousel') ||
            carousel.classList.contains('xmk-mobile-scenes-strip') ||
            carousel.classList.contains('xmk-mobile-voices-exact')
              ? 'center'
              : 'start';
          this.bindLoopingCarousel({ track, prev, next, progressItems, getViewportWidth, initialAlignment });
          return;
        }

        const slides = Array.from(track.children);
        const progressItems = Array.from(
          carousel.querySelectorAll('.xmk-mobile-slider-ui span, .xmk-testimonials__progress span, .xmk-showcase__progress span')
        );
        let activeIndex = 0;
        let currentOffset = 0;
        let startX = null;
        let startOffset = 0;

        const getViewportWidth = () => {
          const parentWidth = track.parentElement?.getBoundingClientRect().width || 0;
          return carousel.getBoundingClientRect().width || parentWidth || track.clientWidth;
        };

        const getMaxOffset = () => Math.max(0, track.scrollWidth - getViewportWidth());
        const clampOffset = (offset) => Math.max(0, Math.min(offset, getMaxOffset()));
        const getOffsetForIndex = (index) => {
          const slide = slides[index];
          return clampOffset(slide ? slide.offsetLeft : 0);
        };
        const getIndexForOffset = (offset) => {
          const maxOffset = getMaxOffset();
          let nearestIndex = 0;
          let nearestDistance = Number.POSITIVE_INFINITY;

          slides.forEach((slide, index) => {
            const slideOffset = Math.min(slide.offsetLeft, maxOffset);
            const distance = Math.abs(slideOffset - offset);

            if (distance < nearestDistance) {
              nearestDistance = distance;
              nearestIndex = index;
            }
          });

          return nearestIndex;
        };

        const updateCarousel = (animate = true) => {
          const maxOffset = getMaxOffset();
          currentOffset = getOffsetForIndex(activeIndex);
          track.style.transition = animate ? '' : 'none';
          track.style.transform = `translate3d(${-currentOffset}px, 0, 0)`;
          prev.toggleAttribute('disabled', currentOffset <= 1 || activeIndex <= 0);
          next.toggleAttribute('disabled', currentOffset >= maxOffset - 1 || activeIndex >= slides.length - 1);
          progressItems.forEach((item, index) => item.classList.toggle('is-active', index === activeIndex));
        };

        const setOffset = (offset) => {
          currentOffset = clampOffset(offset);
          activeIndex = getIndexForOffset(currentOffset);
          track.style.transform = `translate3d(${-currentOffset}px, 0, 0)`;
          prev.toggleAttribute('disabled', currentOffset <= 1 || activeIndex <= 0);
          next.toggleAttribute('disabled', currentOffset >= getMaxOffset() - 1 || activeIndex >= slides.length - 1);
          progressItems.forEach((item, index) => item.classList.toggle('is-active', index === activeIndex));
        };

        const goByCard = (direction) => {
          if (getMaxOffset() <= 1) return;

          activeIndex = Math.max(0, Math.min(activeIndex + direction, slides.length - 1));
          updateCarousel();
        };

        const handlePrev = () => goByCard(-1);
        const handleNext = () => goByCard(1);
        const handleResize = () => updateCarousel();
        const handlePointerDown = (event) => {
          if (event.button !== undefined && event.button !== 0) return;
          if (getMaxOffset() <= 1) return;

          startX = event.clientX;
          startOffset = currentOffset;
          track.classList.add('is-dragging');
          track.setPointerCapture?.(event.pointerId);
          track.style.transition = 'none';
        };
        const handlePointerMove = (event) => {
          if (startX === null) return;

          setOffset(startOffset - (event.clientX - startX));
          event.preventDefault();
        };
        const handlePointerUp = (event) => {
          if (startX === null) return;

          startX = null;
          track.classList.remove('is-dragging');
          track.releasePointerCapture?.(event.pointerId);
          activeIndex = getIndexForOffset(currentOffset);
          updateCarousel();
        };

        prev.addEventListener('click', handlePrev);
        next.addEventListener('click', handleNext);
        track.addEventListener('pointerdown', handlePointerDown);
        track.addEventListener('pointermove', handlePointerMove);
        track.addEventListener('pointerup', handlePointerUp);
        track.addEventListener('pointercancel', handlePointerUp);
        window.addEventListener('resize', handleResize);
        updateCarousel();

        this.disposers.push(() => prev.removeEventListener('click', handlePrev));
        this.disposers.push(() => next.removeEventListener('click', handleNext));
        this.disposers.push(() => track.removeEventListener('pointerdown', handlePointerDown));
        this.disposers.push(() => track.removeEventListener('pointermove', handlePointerMove));
        this.disposers.push(() => track.removeEventListener('pointerup', handlePointerUp));
        this.disposers.push(() => track.removeEventListener('pointercancel', handlePointerUp));
        this.disposers.push(() => window.removeEventListener('resize', handleResize));
      });
    }

    bindMaintenanceStack() {
      const lists = Array.from(this.root.querySelectorAll('.xmk-mobile-maint-list'));
      if (!lists.length) return;

      const mobileQuery = window.matchMedia('(max-width: 749px)');
      const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      const clamp = (value, min, max) => Math.max(min, Math.min(value, max));
      const smoothstep = (value) => {
        const t = clamp(value, 0, 1);
        return t * t * (3 - 2 * t);
      };

      lists.forEach((list) => {
        const exact = list.closest('.xmk-mobile-maint-exact');
        const hero = exact?.querySelector('.xmk-mobile-maint-hero');
        const cards = Array.from(list.querySelectorAll('.xmk-mobile-info-card'));

        if (!exact || !hero || cards.length < 2) return;

        let frameId = null;

        const resetStack = () => {
          delete exact.dataset.xmkMaintStackReady;
          delete list.dataset.xmkMaintStackReady;
          delete list.dataset.xmkMaintStackPhase;
          exact.style.removeProperty('--xmk-maint-stack-card-count');
          exact.style.removeProperty('--xmk-maint-stack-scroll');
          exact.style.removeProperty('--xmk-maint-hero-height');
          exact.style.removeProperty('--xmk-maint-stage-height');
          exact.style.removeProperty('--xmk-maint-transition-range');
          list.style.removeProperty('--xmk-maint-stack-card-count');
          list.style.removeProperty('--xmk-maint-stack-progress');
          list.style.removeProperty('--xmk-maint-stage-height');
          list.style.removeProperty('--xmk-maint-list-top');
          list.style.removeProperty('--xmk-maint-list-after-top');
          list.style.removeProperty('--xmk-maint-stage-fixed-top');
          list.style.removeProperty('--xmk-maint-card-top');

          cards.forEach((card) => {
            card.classList.remove('is-active');
            card.removeAttribute('aria-hidden');
            card.style.removeProperty('--xmk-maint-card-opacity');
            card.style.removeProperty('--xmk-maint-card-y');
            card.style.removeProperty('--xmk-maint-card-scale');
            card.style.removeProperty('--xmk-maint-card-z');
          });
        };

        const enableStack = () => {
          exact.dataset.xmkMaintStackReady = 'true';
          list.dataset.xmkMaintStackReady = 'true';
          exact.style.setProperty('--xmk-maint-stack-card-count', String(cards.length));
          list.style.setProperty('--xmk-maint-stack-card-count', String(cards.length));
        };

        const isEnabled = () => mobileQuery.matches && !reduceMotionQuery.matches;
        const loadCardImages = (card) => {
          card?.querySelectorAll('img[loading="lazy"]').forEach((image) => {
            image.loading = 'eager';
          });
        };

        const updateStack = () => {
          frameId = null;

          if (!isEnabled()) {
            resetStack();
            return;
          }

          enableStack();

          const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
          const scrollY = window.scrollY || window.pageYOffset || 0;
          const exactTop = exact.getBoundingClientRect().top + scrollY;
          const heroHeight = hero.offsetHeight || hero.getBoundingClientRect().height || 580;
          const maxCardHeight = Math.max(
            ...cards.map((card) => card.offsetHeight || card.getBoundingClientRect().height || 0)
          );
          const targetGap = 150;
          const minTopGap = 92;
          const minBottomGap = 96;
          const availableGap = viewportHeight - maxCardHeight;
          const topGap = availableGap >= targetGap * 2
            ? targetGap
            : clamp(availableGap * 0.55, minTopGap, targetGap);
          const bottomGap = availableGap >= targetGap * 2
            ? targetGap
            : clamp(availableGap - topGap, minBottomGap, targetGap);
          const stageHeight = Math.ceil(topGap + maxCardHeight + bottomGap);
          const transitionDistance = Math.round(clamp(viewportHeight * 0.54, 380, 520));
          const transitionRange = transitionDistance * (cards.length - 1);
          const stackScroll = transitionRange + stageHeight;
          const start = exactTop + heroHeight;
          const end = start + transitionRange;
          const rawProgress = transitionRange > 0 ? (scrollY - start) / transitionDistance : 0;
          const progress = clamp(rawProgress, 0, cards.length - 1);
          const baseIndex = clamp(Math.floor(progress), 0, cards.length - 1);
          const mix = baseIndex >= cards.length - 1 ? 0 : progress - baseIndex;
          const slideMix = smoothstep(mix);
          const activeIndex = clamp(slideMix >= 0.5 ? baseIndex + 1 : baseIndex, 0, cards.length - 1);
          const phase = scrollY < start ? 'before' : scrollY > end ? 'after' : 'active';
          const cardTravel = Math.ceil(maxCardHeight + bottomGap);

          list.style.setProperty('--xmk-maint-stack-progress', progress.toFixed(3));
          list.dataset.xmkMaintStackPhase = phase;
          exact.style.setProperty('--xmk-maint-hero-height', `${heroHeight.toFixed(1)}px`);
          exact.style.setProperty('--xmk-maint-stage-height', `${stageHeight.toFixed(1)}px`);
          exact.style.setProperty('--xmk-maint-transition-range', `${transitionRange.toFixed(1)}px`);
          exact.style.setProperty('--xmk-maint-stack-scroll', `${stackScroll.toFixed(1)}px`);
          list.style.setProperty('--xmk-maint-stage-height', `${stageHeight.toFixed(1)}px`);
          list.style.setProperty('--xmk-maint-list-top', `${heroHeight.toFixed(1)}px`);
          list.style.setProperty('--xmk-maint-list-after-top', `${(heroHeight + transitionRange).toFixed(1)}px`);
          list.style.setProperty('--xmk-maint-stage-fixed-top', '0px');
          list.style.setProperty('--xmk-maint-card-top', `${topGap.toFixed(1)}px`);
          loadCardImages(cards[baseIndex]);
          loadCardImages(cards[baseIndex + 1]);

          cards.forEach((card, index) => {
            let y = cardTravel + 28;
            let scale = 0.982;
            let z = 1;

            if (index === baseIndex) {
              y = -cardTravel * slideMix;
              scale = 1 - 0.018 * slideMix;
              z = 4;
            } else if (index === baseIndex + 1) {
              y = cardTravel * (1 - slideMix);
              scale = 0.985 + 0.015 * slideMix;
              z = 5;
            } else if (index < baseIndex) {
              y = -cardTravel;
            }

            if (progress >= cards.length - 1 && index === cards.length - 1) {
              y = 0;
              scale = 1;
              z = 5;
            }

            const isActive = index === activeIndex;
            card.classList.toggle('is-active', isActive);
            card.setAttribute('aria-hidden', isActive ? 'false' : 'true');
            card.style.setProperty('--xmk-maint-card-opacity', '1');
            card.style.setProperty('--xmk-maint-card-y', `${y.toFixed(1)}px`);
            card.style.setProperty('--xmk-maint-card-scale', scale.toFixed(3));
            card.style.setProperty('--xmk-maint-card-z', String(z));
          });
        };

        const requestUpdate = () => {
          if (frameId !== null) return;
          frameId = window.requestAnimationFrame(updateStack);
        };

        const addQueryListener = (query) => {
          query.addEventListener?.('change', requestUpdate);
          query.addListener?.(requestUpdate);
        };

        const removeQueryListener = (query) => {
          query.removeEventListener?.('change', requestUpdate);
          query.removeListener?.(requestUpdate);
        };

        window.addEventListener('scroll', requestUpdate, { passive: true });
        window.addEventListener('resize', requestUpdate);
        addQueryListener(mobileQuery);
        addQueryListener(reduceMotionQuery);
        requestUpdate();

        this.disposers.push(() => {
          if (frameId !== null) {
            window.cancelAnimationFrame(frameId);
          }

          window.removeEventListener('scroll', requestUpdate);
          window.removeEventListener('resize', requestUpdate);
          removeQueryListener(mobileQuery);
          removeQueryListener(reduceMotionQuery);
          resetStack();
        });
      });
    }

    handleKeydown(event) {
      if (event.key === 'Escape' && this.modal?.classList.contains('is-open')) {
        this.closeVideo();
      }
    }

    openVideo(url, trigger) {
      this.lastActiveElement = trigger;
      this.frame.src = getYouTubeEmbedUrl(url);
      this.modal.classList.add('is-open');
      this.modal.removeAttribute('aria-hidden');
      document.body.classList.add('xmk-video-modal-open');

      const close = this.modal.querySelector('.xmk-video-modal__close');
      if (close) {
        window.setTimeout(() => {
          close.focus({ preventScroll: true });
        }, 40);
      }
    }

    closeVideo({ restoreFocus = true } = {}) {
      if (!this.modal || !this.frame) return;

      this.modal.classList.remove('is-open');
      this.modal.setAttribute('aria-hidden', 'true');
      this.frame.src = '';
      document.body.classList.remove('xmk-video-modal-open');

      if (restoreFocus && this.lastActiveElement) {
        this.lastActiveElement.focus({ preventScroll: true });
      }
    }

    destroy() {
      this.closeVideo({ restoreFocus: false });
      this.disposers.forEach((dispose) => dispose());
      this.disposers = [];
      delete this.root.dataset.xmkReady;
      delete this.root.xmkPdpInstance;
    }
  }

  const getRoots = (scope) => {
    const roots = new Set();

    if (scope.matches?.('[data-xmk-pdp]')) {
      roots.add(scope);
    }

    const closestRoot = scope.closest?.('[data-xmk-pdp]');
    if (closestRoot) {
      roots.add(closestRoot);
    }

    scope.querySelectorAll?.('[data-xmk-pdp]').forEach((root) => roots.add(root));

    return Array.from(roots);
  };

  const init = (scope = document, { force = false } = {}) => {
    normalizeIntegratedTabCopy(scope);
    normalizeKeyFeaturesCopy(scope);

    getRoots(scope).forEach((root) => {
      if (force) {
        root.xmkPdpInstance?.destroy();
      }

      if (root.dataset.xmkReady === 'true') return;
      root.dataset.xmkReady = 'true';
      root.xmkPdpInstance = new XtraMakerPdp(root);
    });
  };

  window.__xmkPdpInit = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target, { force: true });
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const roots = getRoots(event.target);

    roots.forEach((root) => {
      root.xmkPdpInstance?.destroy();
    });

    window.setTimeout(() => {
      roots.forEach((root) => init(root));
    }, 0);
  });
})();

(() => {
  const hiddenAnchorTabsProductPath = '/products/xtramaker-5-in-1-smart-desktop-dtf-printer-deposit-reservation-1';

  const hideDepositReservationAnchorTabs = () => {
    if (!window.location.pathname.includes(hiddenAnchorTabsProductPath)) return;

    document.querySelectorAll('.xmk-product-anchor-tabs').forEach((tabs) => {
      tabs.hidden = true;
      tabs.style.display = 'none';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideDepositReservationAnchorTabs, { once: true });
  } else {
    hideDepositReservationAnchorTabs();
  }

  document.addEventListener('shopify:section:load', hideDepositReservationAnchorTabs);
})();

(() => {
  const reserveLinkPages = new Set(['/', '/pages/xtramaker-m1']);
  const legacyReserveCartPath = '/cart/45720772247749:1';
  const reserveProductPath = '/products/xtramaker-5-in-1-smart-desktop-dtf-printer-deposit-reservation';

  const getNormalizedPath = () => window.location.pathname.replace(/\/+$/, '') || '/';

  const normalizeReserveLinks = (scope = document) => {
    if (!reserveLinkPages.has(getNormalizedPath())) return;

    const anchors = [];
    if (scope.matches?.('a')) anchors.push(scope);
    scope.querySelectorAll?.('a').forEach((anchor) => anchors.push(anchor));

    anchors.forEach((anchor) => {
      let hrefPath = '';
      try {
        hrefPath = new URL(anchor.getAttribute('href') || '', window.location.origin).pathname;
      } catch (error) {
        return;
      }

      if (hrefPath !== legacyReserveCartPath) return;
      if (!/Reserve Now/i.test(anchor.textContent || '')) return;

      anchor.setAttribute('href', reserveProductPath);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => normalizeReserveLinks(), { once: true });
  } else {
    normalizeReserveLinks();
  }

  document.addEventListener('shopify:section:load', (event) => normalizeReserveLinks(event.target));
})();
